"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const default_path_component_1 = __importDefault(require("./default.path.component"));
exports.default = default_path_component_1.default;
